import { render } from "./contactinput.vue?vue&type=template&id=0421c4b6&scoped=true"
import script from "./contactinput.vue?vue&type=script&lang=js"
export * from "./contactinput.vue?vue&type=script&lang=js"

import "./contactinput.vue?vue&type=style&index=0&id=0421c4b6&scoped=true&lang=css"
import "./contactinput.vue?vue&type=style&index=1&id=0421c4b6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0421c4b6"]])

export default __exports__